import { Button } from "@povio/ui";
import { useRouter } from "next/router";
import { useCallback } from "react";

import { RefreshIcon } from "@/assets/icons/general/Refresh";
import { PageContainer } from "@/components/home/sections/PageContainer";
import { RouteConfig } from "@/config/route.config";
import { ProfileQueries } from "@/data/profile/profile.queries";
import useInvalidateProfile from "@/hooks/profile/useInvalidateProfile";
import { useToast } from "@/hooks/useToast";

export const ProcessingFailedAlert = () => {
  const router = useRouter();
  const { errorToast } = useToast();
  const { invalidateAndRefetchProfile } = useInvalidateProfile();
  const { refetch: refetchReset } = ProfileQueries.useReset({ enabled: false });

  const handleRetry = useCallback(async () => {
    try {
      const res = await refetchReset();
      if (res.status === "error") {
        errorToast({
          text: "There was an error resetting your profile, try again later.",
        });
      } else if (res.status === "success") {
        await invalidateAndRefetchProfile();
        router.replace(RouteConfig.Onboarding);
      }
    } catch (error) {
      console.error(error);
      errorToast({
        text: "There was an error resetting your profile, try again later.",
      });
    }
  }, [refetchReset, invalidateAndRefetchProfile, router, errorToast]);

  return (
    <PageContainer>
      <Button
        color="warning"
        size="s"
        width="fill"
        variant="outlined"
        icon={RefreshIcon}
        iconPosition="left"
        onPress={handleRetry}
      >
        Processing failed. Click here to try again.
      </Button>
    </PageContainer>
  );
};
